// extracted by mini-css-extract-plugin
export default {"fontlarge":"1.5em","makerPink":"pink","makerWhite":"white"};